import React from 'react';
import { Box } from '@material-ui/core';
import Dropzone from 'react-dropzone';
import Alert from '@material-ui/lab/Alert';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import './profile-image-style.css';

export const SelectProfileImage = ({ setOpen, image, setImage }) => {
  const acceptFile = (file) => {
    const fileTypes = ['image/jpg', 'image/jpeg', 'image/png'];
    if (file.length > 0 && fileTypes.includes(file[0].type)) {
      setImage({ ...image, temp: URL.createObjectURL(file[0]) });
      setOpen(true);
    }
  };

  const OverLay = () => {
    return (
      <div className='change-profile-overlay'>
        <AddAPhotoIcon color='action' fontSize='large' />
      </div>
    );
  };

  const UploadBox = () => {
    return (
      <Box className='profile-uploadBox'>
        <label htmlFor='profile_image' display='block' name='uploadImage'>
          <input
            type='file'
            accept='image/*'
            hidden
            id='profile_image'
            onChange={(e) => acceptFile(e.target.files)}
            name='image'
            required
          />
          <Dropzone
            onDrop={(file) => acceptFile(file)}
            multiple={false}
            style={{
              width: '100%',
              height: '100%',
            }}
            onClick={() => {
              setOpen(true);
            }}
          >
            {({ getRootProps }) => (
              <Box boxShadow={3} className='profile-image' {...getRootProps()}>
                <img
                  src={image.value ? image.value : image.default}
                  alt='profile'
                  className='profile-image'
                />
                <OverLay />
              </Box>
            )}
          </Dropzone>
        </label>
      </Box>
    );
  };

  return (
    <div>
      {image.error && (
        <Alert severity='error' className='profile-image-error'>
          {image.error}
        </Alert>
      )}
      <UploadBox />
    </div>
  );
};
